import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { syncStoredAttempts } from '@/lib/attempt-sync-client';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { useAuthStore } from '@/stores/authStore';

export function PendingAttemptsFlusher() {
  const userId = useAuthStore((state) => state.user?.id);
  const { online } = useOnlineStatus();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!userId || !online) return undefined;
    let cancelled = false;
    void (async () => {
      await syncStoredAttempts(userId);
      if (cancelled) return;
      await queryClient.refetchQueries({ predicate: (query) => query.state.status === 'error' });
    })();
    return () => {
      cancelled = true;
    };
  }, [userId, online, queryClient]);

  return null;
}
